import { cloneLayout, validateLayout } from "./report-layout";

/**
 * Personal, browser-local display preferences. Only the schema version and a validated
 * layout are stored — never report HTML, amounts, tokens or warehouse access.
 */

const STORAGE_PREFIX = "inventory-value-report:layout";

export const LAYOUT_PREFERENCE_NOTICE =
  "Tampilan tersimpan tidak dapat digunakan sehingga diabaikan; tampilan default dipakai.";

export const getLayoutPreferenceKey = (userId) => `${STORAGE_PREFIX}:${userId}`;

const resolveStorage = (storage) => {
  if (storage) return storage;
  try {
    return window.localStorage;
  } catch {
    return null;
  }
};

export const loadLayoutPreference = ({ userId, options, storage }) => {
  const store = resolveStorage(storage);
  if (!userId || !options || !store) return { layout: null, notice: null };

  let raw;
  try {
    raw = store.getItem(getLayoutPreferenceKey(userId));
  } catch {
    return { layout: null, notice: null };
  }
  if (raw === null || raw === undefined) return { layout: null, notice: null };

  try {
    const stored = JSON.parse(raw);
    if (
      stored?.schemaVersion !== options.schemaVersion ||
      Object.keys(validateLayout(stored.layout, options)).length > 0
    ) {
      return { layout: null, notice: LAYOUT_PREFERENCE_NOTICE };
    }
    return { layout: cloneLayout(stored.layout), notice: null };
  } catch {
    return { layout: null, notice: LAYOUT_PREFERENCE_NOTICE };
  }
};

export const saveLayoutPreference = ({ userId, layout, options, storage }) => {
  const store = resolveStorage(storage);
  if (
    !userId ||
    !store ||
    Object.keys(validateLayout(layout, options)).length > 0
  ) {
    return false;
  }
  try {
    store.setItem(
      getLayoutPreferenceKey(userId),
      JSON.stringify({
        schemaVersion: options.schemaVersion,
        layout: cloneLayout(layout),
      })
    );
    return true;
  } catch {
    return false;
  }
};
